<template>
	<div
		v-if="show"
		class="flex fixed w-full z-40 inset-0"
	>
		<div
			@click="closeOnClickOutside"
			class="fixed inset-0 bg-gray-900 bg-opacity-50"
		></div>
		<slot name="layout">
			<div class="w-full max-w-full md:max-w-3xl m-auto z-10">
				<div
					class="relative shadow-lg shadow-black/20 rounded-xl p-6 md:p-8"
					:class="themes[theme].background"
				>
					<button
						@click="close"
						class="absolute right-0 top-0 m-1 p-2"
						:class="themes[theme].button"
						type="button"
					>
						<Icon icon="icon-park-outline:close" />
					</button>
					<div :class="themes[theme].text">
						<slot :data="data"></slot>
					</div>
				</div>
			</div>
		</slot>
	</div>
</template>

<script lang="ts" setup>
import { useModalStore } from "~/store/modal";
import { Icon } from "@iconify/vue";
import { PropType } from "vue";
const themes = ref({
	default: {
		background: "bg-white",
		button: "text-gray-500",
		text: "text-gray-500",
	},
	primary: {
		background: "bg-primary",
		button: "",
		text: "text-[#F8AC36]",
	},
});
const props = defineProps({
	config: {
		default: {
			closeOnClick: true,
		},
	},
	theme: {
		type: String as PropType<"default" | "primary">,
		default: "default",
	},
});

const modalStore = useModalStore();
const show = ref(false);
const data = ref(null);

watch(show, (show) => {
	if (show) modalStore.open();
	else modalStore.close();
});

const open = (payload: any) => {
	data.value = payload;
	if (!show.value) show.value = true;
};

const close = () => {
	if (show.value) show.value = false;
};

const closeOnClickOutside = () => {
	if (props.config.closeOnClick === true) {
		if (show.value) show.value = false;
	}
};

defineExpose({ open, close });
</script>

<style scoped></style>
